export const COOKIE_CONSENT_STORAGE_KEY = 'cookie-consent'
export const COOKIE_CONSENT_EVENT = 'divemate:cookie-consent'

export type CookieConsentValue = 'all' | 'essential'

export function isCookieConsentValue(value: unknown): value is CookieConsentValue {
  return value === 'all' || value === 'essential'
}

export function isAnalyticsConsent(value: unknown): boolean {
  return value === 'all'
}

export function readCookieConsent(storage: Pick<Storage, 'getItem'> | null | undefined): CookieConsentValue | null {
  if (!storage) return null
  const raw = storage.getItem(COOKIE_CONSENT_STORAGE_KEY)
  return isCookieConsentValue(raw) ? raw : null
}

export function writeCookieConsent(
  storage: Pick<Storage, 'setItem'>,
  value: CookieConsentValue,
  dispatch: (event: Event) => void = (event) => window.dispatchEvent(event),
): void {
  storage.setItem(COOKIE_CONSENT_STORAGE_KEY, value)
  dispatch(new CustomEvent(COOKIE_CONSENT_EVENT, { detail: { consent: value } }))
}

export function clearCookieConsent(
  storage: Pick<Storage, 'removeItem'>,
  dispatch: (event: Event) => void = (event) => window.dispatchEvent(event),
): void {
  storage.removeItem(COOKIE_CONSENT_STORAGE_KEY)
  dispatch(new CustomEvent(COOKIE_CONSENT_EVENT, { detail: { consent: null } }))
}
